import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { LandingFooter } from "src/components/LandingPage/LandingFooter";
import { colorPublicMenuBg } from "src/design/tokens";
import { PublicPageHeader } from "./PublicPageHeader";

// Shared layout for anonymous public restaurant pages (menu + booking): the
// minimal centered-logo header, the routed page, and the landing footer.
export const PublicPageLayout = () => (
  <Box sx={{ backgroundColor: colorPublicMenuBg, minHeight: "100vh" }}>
    <PublicPageHeader />
    <Outlet />
    <LandingFooter />
  </Box>
);
